import { render, staticRenderFns } from "./Subdivisions.vue?vue&type=template&id=674da846&"
import script from "./Subdivisions.vue?vue&type=script&lang=ts&"
export * from "./Subdivisions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports